import { render, staticRenderFns } from "./CreateEmailTemplateDialog.vue?vue&type=template&id=2892c9b2"
import script from "./CreateEmailTemplateDialog.vue?vue&type=script&lang=js"
export * from "./CreateEmailTemplateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports